export interface InventoryAttachmentRequest {
  attachmentId?: number;
  inventoryDetailId?: number;
  fileName: string;
  dateUploaded: string;
  status: string;
  fileSize?: number;
  contentPurged?: boolean;
}

export interface InventoryItemRequest {
  id: number;
  itemName: string;
  itemDescription: string;
  quantity: number;
  cost: number;
  dateOfPurchase: string;
  additionalItemDetails?: string;
  preLossCondition?: string;
  wherePurchased?: string;
  methodOfPayment?: string;
  specifyMethodOfPayment?: string;
  receiptOrInvoiceIncluded?: string;
  reasonForNoDocumentation?: string;
  status?: string;
  attachments?: InventoryAttachmentRequest[];
  attachmentCount?: number;
  dateUploaded: string;
}

/** In-progress Add item fields saved before the user clicks Add. */
export interface InventoryPendingForm {
  itemName: string;
  itemDescription: string;
  quantity: string;
  cost: string;
  dateOfPurchase: string;
  additionalItemDetails: string;
  preLossCondition: string;
  wherePurchased: string;
  methodOfPayment: string;
  specifyMethodOfPayment: string;
  receiptOrInvoiceIncluded: string;
  reasonForNoDocumentation: string;
}

export interface InventorySubmissionDraftRequest {
  items: InventoryItemRequest[];
  nextItemId: number;
  hasSubmitted: boolean;
  hasPendingChangesAfterSubmit: boolean;
  pendingForm?: InventoryPendingForm | null;
  autoSubmittedOn?: string | null;
  autoSubmitReason?: string | null;
}

export class SubmitInventoryRequest {
  claimId: string;
  items: InventoryItemRequest[];
  lob: string;
  source: string;
  vendorId: string;
  procUnit: string;
  claimNumber: string;
}

export interface InventorySubmissionSaveResponse {
  success: boolean;
}

export interface InventoryAttachmentUploadResponse {
  success: boolean;
  attachmentId?: number;
  fileName?: string;
  dateUploaded?: string;
  fileSize?: number;
  statusDescription?: string;
}

export class SubmitInventoryResponse {
  confirmationNumber: string;
  pdfGenerated?: boolean;
  previewOnly?: boolean;
  statusDescription?: string;
}
